<template>
    <div>
        <div class="row">
            <div v-for="(col, colIndex) in inputsChunkedEx"
                 :key="'col_' + colIndex"
                 class="col">
                <div v-for="(input, inputIndex) in col"
                     :key="inputIndex"
                     class="form-group row">
                    <label class="col-sm-4 col-form-label"
                           :for="input.id">
                        {{input.label}}
                    </label>
                    <div class="col-sm-8">
                        <div v-if="input.type == 'text'" class="input-group">
                            <input type="text"
                                   class="form-control form-control-sm"
                                   :id="compKey + '_' + input.id"
                                   :ref="input.id"
                                   :placeholder="input.placeholder"
                                   :value="getValue(input, values, '')"
                                   :disabled="!(input.allowEdit && input.allowEdit == true)"
                                   @input="handleInputEvent(input.id)">
                            <div class="input-group-append" v-if="input.copy">
                                <button class="btn btn-outline-secondary btn-sm"
                                        type="button"
                                        v-b-tooltip.hover :title="copyToPopupText" v-on:click="copyToClipboard(getValue(input, values, ''))">
                                    <i class="far fa-copy"></i>
                                </button>
                            </div>
                            <div class="input-group-append" v-if="input.edit">
                                <button class="btn btn-outline-secondary btn-sm"
                                        type="button"
                                        v-b-tooltip.hover title="Edit" v-on:click="openEditModal('edit-modal' + componentKey, input.id, input.label)">
                                    <i class="far fa-edit"></i>
                                </button>
                            </div>
                        </div>




                        <select v-if="input.type == 'select'"
                                class="form-control  form-control-sm"
                                :id="compKey + '_' + input.id"
                                :ref="input.id"
                                @input="handleInputEvent(input.id)">
                            <option v-for="(option, index) in input.options"
                                    :key="input.id + index"
                                    :value="index"
                                    :disabled="!(input.allowEdit && input.allowEdit == true)"
                                    :selected="input.dataPath ? option.label == Object.byString(values, input.dataPath) : false">
                                {{option.label}}
                            </option>
                        </select>

                        <textarea v-if="input.type == 'textarea'"
                                  class="form-control form-control-sm"
                                  :id="compKey + '_' + input.id"
                                  :ref="input.id"
                                  :placeholder="input.placeholder"
                                  :disabled="!(input.allowEdit && input.allowEdit == true)"
                                  :value="getValue(input, values, '')"
                                  @input="handleInputEvent(input.id)"
                                  rows="3">
              
            </textarea>

                        <div v-if="input.type == 'anchor'">
                            <a v-if="getValue(input, values, null)" :href="getValue(input, values, '')" :target="input.target">{{input.link_text ? input.link_text : getValue(input, values, '')}}</a>
                            <span v-else>NO LINK</span>
                        </div>
                    </div>
                    <b-tooltip v-if="input.tooltip && input.tooltip != ''"
                               :target="input.id"
                               :title="input.tooltip">
                    </b-tooltip>
                </div>
            </div>
        </div>
        <b-modal :id="'edit-modal' + componentKey" centered :title="'Update ' + modalTitle">
            <component v-bind:is="currentFormComponent" class="edit-modal-forms"></component>
            <template #modal-footer>
                <b-button @click="closeEditModal('edit-modal' + componentKey)" variant="outline-primary" size="sm">Close</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

    let chunk = (arr, chunkSize, cache = []) => {
        const tmp = [...arr]
        while (tmp.length) cache.push(tmp.splice(0, chunkSize))
        return cache
    }

    Object.byString = function (o, s) {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        var a = s.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }
        return o;
    }


    Object.set = function (obj, path, value) {
        var schema = obj;
        var pList = path.split('.');
        var len = pList.length;
        for (var i = 0; i < len - 1; i++) {
            var elem = pList[i];
            if (!schema[elem]) schema[elem] = {}
            schema = schema[elem];
        }

        schema[pList[len - 1]] = value;
    }

    export default {
        name: 'SimpleDisplayGrid',
        props: {
            inputs: Array,
            values: Object,
            columnCount: Number,
            componentKey: {
                type: String,
                default: ''
            },
            editForms: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        data: () => {
            return {
                changedValues: {},
                copyToPopupText: 'Copy to clipboard',
                showComponentModal: false,
                modalTitle: '',
                modalFormType: ''
            }
        },
        computed: {
            compKey() {
                return this.$vnode.key
            },
            inputsChunkedEx() {
                let tmp = this.inputs.length / this.columnCount
                let inputsEx = this.inputs.filter(i => {
                    if (i.visible) {
                        return i.visible(this.values)
                    }

                    return true
                })
                return chunk(inputsEx, Math.ceil(tmp))
            },
            inputsChunked() {
                let tmp = this.inputs.length / this.columnCount
                return chunk(this.inputs, Math.ceil(tmp))
            },
            currentFormComponent() {
                return this.editForms.find((e) => e.name == this.modalFormType)
            }
        },
        methods: {
            getValue(obj, dataValues, defVal) {
                if (obj.customFormatter) {
                    return obj.customFormatter(obj.dataPath ? Object.byString(dataValues, obj.dataPath) : defVal)
                } else {
                    return obj.dataPath ? Object.byString(dataValues, obj.dataPath) : defVal
                }
            },
            isVisible(obj, dataValues) {
                if (obj.visible) {
                    console.log(obj.visible(dataValues))
                    return obj.visible(dataValues)
                }

                return true
            },
            handleInputEvent(e) {

                var input = this.inputs.filter(i => { return i.id === e })[0]

                if (input.type == 'text' || input.type == 'textarea') {
                    this.changedValues[e] = this.$refs[e][0].value
                }

                if (input.type == 'select') {
                    this.changedValues[e] = {
                        ...input.options[this.$refs[e][0].value]
                    }
                }

                this.$emit('values-changed', this.changedValues)
            },
            copyToClipboard(val) {

                var tempInput = document.createElement("input");
                tempInput.value = val;
                document.body.appendChild(tempInput);
                tempInput.select();
                try {
                    if (document.execCommand('copy')) {
                        this.copyToPopupText = 'Copied'
                        let self = this
                        setTimeout(function () {
                            self.copyToPopupText = 'Copy to clipboard'
                        }, 2000);
                    }

                } catch (err) {
                    console.log(err)
                }

                document.body.removeChild(tempInput);


            },
            openEditModal(id, type, label) {
                this.modalFormType = type + 'Form';
                this.modalTitle = label
                this.$bvModal.show(id);
            },
            closeEditModal(id) {
                this.$bvModal.hide(id);
            }
        }
    }

</script>

<style scoped>
</style>